export const paymentMethods = {
    online: "Online",
    bank: "Transferencia bancaria",
    cash: "Efectivo",
    daviplata: "Daviplata",
    nequi: "Nequi",
    terminal: "Pago con datafono",
    locker: "Locker",
    terminal1: "Datáfono 1",
    terminal2: "Datáfono 2",
    terminal3: "Datáfono 3",
    bre_b: "Bre-b"
};

export const paymentMethodsMessageClass = {
    online: "text-theme-info",
    bank: "text-theme-primary",
    cash: "text-theme-success",
    daviplata: "text-brand-red",
    nequi: "text-brand-magenta",
    terminal: "text-theme-warning",
    locker: "text-brand-purple",
    terminal1: "text-theme-warning",
    terminal2: "text-theme-warning",
    terminal3: "text-theme-warning",
    bre_b: "text-brand-blue"
};

export const paymentMethodsOutput = {
    cash: "Efectivo",
    daviplata: "Daviplata",
    nequi: "Nequi",
    terminal: "Tarjeta",
    bre_b: "Bre-b"
};

export const paymentMethodsMerchant = {
    cash: "Efectivo",
    daviplata: "Daviplata",
    nequi: "Nequi",
    terminal: "Datáfono",
    bre_b: "Bre-b"
};

export const paymentMethodsCodes = {
    cash_on_delivery: "Pago contra entrega",
    online: "Online",
    bank: "Transferencia bancaria",
    cash: "Efectivo",
    daviplata: "Daviplata",
    nequi: "Nequi",
    lockerpickup: "Locker",
    terminal: "Datáfono",
    terminal1: "Datáfono 1",
    terminal2: "Datáfono 2",
    terminal3: "Datáfono 3",
    bre_b: "Bre-b"
};

export const paymentMethodsCodesReader = {
    online: "Online",
    bank: "Transferencia bancaria",
    cash: "Efectivo",
    daviplata: "Daviplata",
    nequi: "Nequi",
    locker: "Locker",
    terminal: "Datáfono",
    terminal1: "Datáfono 1",
    terminal2: "Datáfono 2",
    terminal3: "Datáfono 3",
    bre_b: "Bre-b"
};
